// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%23b51f25%27 viewBox=%270 0 20 20%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcb-assembly-form{
    width: 80%;
    margin: auto auto 2em auto;
    padding: 1.25rem;
    background-color: #ffffff;
    border-radius: 0.625em;
    box-shadow: 0em 0.25em 0.625m rgba(0,0,0,0.1);
}

.form-title{
    text-align: center;
    font-family: "Fivo Sans Bold", sans-serif;
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 0.9375rem;
}
.info-tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin-left: 0.5em;
}
.tooltip-icon {
    font-size: 1em;
    color: #b51f25;
    cursor: pointer;
    border-radius: 50%;
    padding:0.125em;
    transition: color 0.3s ease-in-out;
}
.tooltip-icon:hover {
    color: #b51f24cc;
}
.tooltip-text {
    visibility: hidden;
    width: 11.25em;
    background-color: #222;
    color: #fff;
    text-align: center;
    border-radius: 0.25em;
    padding:0.5em;
    position: absolute;
    z-index: 10;
    bottom: 125%; /* Position above the icon */
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    font-size: 0.75em;
    white-space: normal;
    line-height: 1.3;
}
.info-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
.pcb-table{
    width: 100%;
    border-collapse: collapse;
    margin-top: 0.625em;
}

.pcb-table td{
    padding: 0.625em;
    align-items: left;
    align-content: left;
    text-align: left;
    font-family: "Fivo Sans Regular", sans-serif;
    font-size: 1rem;
}
.pcb-table td select {
    width: auto;
    padding: 0.5em;
    padding-right: 2em;
    border: 1px solid #b51f25;
    border-radius: 0.5em;
    font-family: "Fivo Sans Regular", sans-serif;
    font-size: 1em;
    background-color: #fff;
    transition: all 0.3s ease-in-out;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
    appearance: none;
}
.optional-parameters table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 0.8em;
}
.optional-parameters thead {
    text-align: left;
    font-family: "Fivo Sans Bold", sans-serif;
    color: #333;
    font-size: 1.1em;
    padding-bottom: 0.5em;

}
.optional-parameters tbody {
    font-family: "Fivo Sans Regular", sans-serif;
    color: #333;
}
.optional-parameters td {
    padding: 0.5em 0.8em;
    text-align: left;
    font-family: "Fivo Sans Regular", sans-serif;
    font-size: 1em;
    vertical-align: middle;
}
.optional-parameters td input, .optional-parameters td select {
    width: 16em;
    padding: 0.5em;
    border: 1px solid #b51f25;
    border-radius: 0.5em;
    font-family: "Fivo Sans Regular", sans-serif;
    font-size: 1em;
    background-color: #fff;
    transition: all 0.3s ease-in-out;
}
.optional-parameters input:focus, .optional-parameters select:focus {
    border-color: #e63946;
    outline: none;
    box-shadow: 0em 0em 0.3125em rgba(181,31,37,0.5);
}
.optional-parameters select {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
    appearance: none;
}
.optional-parameters label {
    font-size: 1em;
    font-family: "Fivo Sans Regular", sans-serif;
    display: block;
    margin-bottom: 0.2em;
}
.optional-parameters {
    width: auto;
    background-color: #ffe6f0;
    padding:1.2em;
    border: 1px solid #999;
    border-radius: 0.5em;
    margin-bottom: 1.5em;
    box-shadow: 0em 0.125em 0.3125em rgba(0,0,0,0.1);
}

/* Responsive table: Switch columns to rows on small screens */
@media screen and (max-width: 768px) {
    .optional-parameters table {
        width: 100%;
        display: block;
    }

    .optional-parameters thead {
        display: none;
    }

    .optional-parameters tbody,
    .optional-parameters tr {
        display: block;
        width: 100%;
    }

    .optional-parameters td {
        display: block;
        width: 100%;
        text-align: left;
        padding: 0.8em 0;
    }

    .optional-parameters td select,
    .optional-parameters td input {
        width: 75%;
    }
    .remark-input {
        width: calc(0.75*(4em + 100%));
        padding: 0.5em;
        margin: 0.5em;
        border: 1px solid #ccc;
        border-radius: 0.5em;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PCBSelection/PCBAssemblyForm.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,iBAAiB;IACjB,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAE,4BAA4B;IAC1C,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,iEAAiE;IACjE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;AACnB;AACA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,4CAA4C;IAC5C,cAAc;IACd,sBAAsB;IACtB,gCAAgC;IAChC,yDAAkQ;IAClQ,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IAErB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,qBAAqB;;AAEzB;AACA;IACI,4CAA4C;IAC5C,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,4CAA4C;IAC5C,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,4CAA4C;IAC5C,cAAc;IACd,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,gDAAgD;AACpD;AACA;IACI,yDAAkQ;IAClQ,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IAErB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,4CAA4C;IAC5C,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA,8DAA8D;AAC9D;IACI;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,UAAU;IACd;IACA;QACI,8BAA8B;QAC9B,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,oBAAoB;IACxB;AACJ","sourcesContent":[".pcb-assembly-form{\n    width: 80%;\n    margin: auto auto 2em auto;\n    padding: 1.25rem;\n    background-color: #ffffff;\n    border-radius: 0.625em;\n    box-shadow: 0em 0.25em 0.625m rgba(0,0,0,0.1);\n}\n\n.form-title{\n    text-align: center;\n    font-family: \"Fivo Sans Bold\", sans-serif;\n    font-size: 1.5rem;\n    color: #333;\n    margin-bottom: 0.9375rem;\n}\n.info-tooltip {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    margin-left: 0.5em;\n}\n.tooltip-icon {\n    font-size: 1em;\n    color: #b51f25;\n    cursor: pointer;\n    border-radius: 50%;\n    padding:0.125em;\n    transition: color 0.3s ease-in-out;\n}\n.tooltip-icon:hover {\n    color: #b51f24cc;\n}\n.tooltip-text {\n    visibility: hidden;\n    width: 11.25em;\n    background-color: #222;\n    color: #fff;\n    text-align: center;\n    border-radius: 0.25em;\n    padding:0.5em;\n    position: absolute;\n    z-index: 10;\n    bottom: 125%; /* Position above the icon */\n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n    font-size: 0.75em;\n    white-space: normal;\n    line-height: 1.3;\n}\n.info-tooltip:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n}\n.pcb-table{\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 0.625em;\n}\n\n.pcb-table td{\n    padding: 0.625em;\n    align-items: left;\n    align-content: left;\n    text-align: left;\n    font-family: \"Fivo Sans Regular\", sans-serif;\n    font-size: 1rem;\n}\n.pcb-table td select {\n    width: auto;\n    padding: 0.5em;\n    padding-right: 2em;\n    border: 1px solid #b51f25;\n    border-radius: 0.5em;\n    font-family: \"Fivo Sans Regular\", sans-serif;\n    font-size: 1em;\n    background-color: #fff;\n    transition: all 0.3s ease-in-out;\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='%23b51f25' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'/></svg>\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 16px;\n    -webkit-appearance: none;\n    appearance: none;\n}\n.optional-parameters table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 0.8em;\n}\n.optional-parameters thead {\n    text-align: left;\n    font-family: \"Fivo Sans Bold\", sans-serif;\n    color: #333;\n    font-size: 1.1em;\n    padding-bottom: 0.5em;\n\n}\n.optional-parameters tbody {\n    font-family: \"Fivo Sans Regular\", sans-serif;\n    color: #333;\n}\n.optional-parameters td {\n    padding: 0.5em 0.8em;\n    text-align: left;\n    font-family: \"Fivo Sans Regular\", sans-serif;\n    font-size: 1em;\n    vertical-align: middle;\n}\n.optional-parameters td input, .optional-parameters td select {\n    width: 16em;\n    padding: 0.5em;\n    border: 1px solid #b51f25;\n    border-radius: 0.5em;\n    font-family: \"Fivo Sans Regular\", sans-serif;\n    font-size: 1em;\n    background-color: #fff;\n    transition: all 0.3s ease-in-out;\n}\n.optional-parameters input:focus, .optional-parameters select:focus {\n    border-color: #e63946;\n    outline: none;\n    box-shadow: 0em 0em 0.3125em rgba(181,31,37,0.5);\n}\n.optional-parameters select {\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='%23b51f25' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'/></svg>\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 16px;\n    -webkit-appearance: none;\n    appearance: none;\n}\n.optional-parameters label {\n    font-size: 1em;\n    font-family: \"Fivo Sans Regular\", sans-serif;\n    display: block;\n    margin-bottom: 0.2em;\n}\n.optional-parameters {\n    width: auto;\n    background-color: #ffe6f0;\n    padding:1.2em;\n    border: 1px solid #999;\n    border-radius: 0.5em;\n    margin-bottom: 1.5em;\n    box-shadow: 0em 0.125em 0.3125em rgba(0,0,0,0.1);\n}\n\n/* Responsive table: Switch columns to rows on small screens */\n@media screen and (max-width: 768px) {\n    .optional-parameters table {\n        width: 100%;\n        display: block;\n    }\n\n    .optional-parameters thead {\n        display: none;\n    }\n\n    .optional-parameters tbody,\n    .optional-parameters tr {\n        display: block;\n        width: 100%;\n    }\n\n    .optional-parameters td {\n        display: block;\n        width: 100%;\n        text-align: left;\n        padding: 0.8em 0;\n    }\n\n    .optional-parameters td select,\n    .optional-parameters td input {\n        width: 75%;\n    }\n    .remark-input {\n        width: calc(0.75*(4em + 100%));\n        padding: 0.5em;\n        margin: 0.5em;\n        border: 1px solid #ccc;\n        border-radius: 0.5em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
